// svc-offer `app_exclusive` schedule rules (src/api/v1/validators/scheduleValidator.js in svc-offer).
export const APP_EXCLUSIVE_SCHEDULE_TYPE = 'app_exclusive';
export const APP_EXCLUSIVE_BRAND = 'luxuryescapes';
// Every region's slot starts at 6:00am Sydney time, so the calendar is drawn in Sydney time.
export const APP_EXCLUSIVE_TIMEZONE = 'Australia/Sydney';
// Hour of day (Sydney) every slot starts and ends.
export const APP_EXCLUSIVE_START_HOUR = 6;
// A slot runs for one or two whole days (24 or 48 hours, 6:00am to 6:00am Sydney time).
export const APP_EXCLUSIVE_LENGTHS_DAYS = [1, 2] as const;
export type AppExclusiveLengthDays = (typeof APP_EXCLUSIVE_LENGTHS_DAYS)[number];
// Most deals one region can hold on the same day. svc-offer returns the live value as `maxPerDay`; this is
// only the fallback while that lookup loads or fails.
export const APP_EXCLUSIVE_MAX_PER_DAY = 2;
